export default __webpack_public_path__ + "static/media/kitchen3-afterJ-1920w.1dd35c49.png";